import React, { FC } from "react";
import { TableBody, TableCell } from "@mui/material";
import { ProjectResponse } from "@api/projects/mutations";
import { EmptyRow, renderCheckRow, RenderRow } from "@components/create-project/table/helpers";
import { useTranslation } from "react-i18next";

interface TechnicalCalculationsTableProps {
  offer: ProjectResponse;
}

export const TechnicalCalculationsTable: FC<TechnicalCalculationsTableProps> = ({ offer }) => {
  const { t } = useTranslation();

  return (
    <TableBody>
      <tr>
        <TableCell className="w-full bg-black" sx={{p: "1px 4px", color: "white"}} colSpan={5}>
          {t("project.table.technicalCalculation")}
        </TableCell>
      </tr>
      <RenderRow
        offer={offer}
        label={t('project.table.case1.annualPerformanceFactor')}
        name={'Annual Performance Factor (JAZ)'}
        caseType='TC'
      />
      <RenderRow
        offer={offer}
        label={t('project.table.case1.electricalPowerHP')}
        name={'Electrical power HP'}
        caseType='TC'
        units='kW'
      />
      <RenderRow
        offer={offer}
        label={t('project.table.case1.electricalPowerAHEx')}
        name="Electrical power AHEx"
        caseType="TC"
        units="kW"
      />
      <RenderRow
        offer={offer}
        label={t('project.table.case1.electricalPowerAHP')}
        name="Electrical power AHP"
        caseType="TC"
        units="kW"
      />
      <EmptyRow />
      <RenderRow
        offer={offer}
        label={t('project.table.case1.probesLengthTotal')}
        name="Probes length total"
        caseType="TC"
        units="m"
      />
      <RenderRow
        offer={offer}
        label={t('project.table.case1.probesFieldArea')}
        name="Probes field area"
        caseType="TC"
        units="m2"
      />
      {renderCheckRow(offer, t('project.table.case1.checkExteriorAreaVsProbesFieldArea'))}
      <RenderRow
        offer={offer}
        label={t('project.table.case1.checkWithdrawlPowerInProbes')}
        name="CHECK Withdrawl Power in Probes"
        caseType="TC"
        units="kWh/m2*a"
      />
      <EmptyRow />
      <RenderRow
        offer={offer}
        label={t('project.table.case1.totalPowerRequirement')}
        name="Total Power requirement"
        caseType="TC"
        units="MWh/a"
      />

      <RenderRow
        offer={offer}
        label={t('project.table.case1.pvYieldTotal')}
        name="PV yield total"
        caseType="TC"
        units="MWh/a"
        underline
      />
      <RenderRow
        offer={offer}
        label={t('project.table.case1.totalElectricityDemandFromGrid')}
        name="Total electricity demand from grid"
        caseType="TC"
        units="MWh/a"
        fontWeight={700}
      />
    </TableBody>
  );
};
